// @flow

export const MIN_PASSWORD_LENGTH = 12;

export const PROMPT_TYPE_LOGIN = 'login';
export const PROMPT_TYPE_REGISTER = 'create';
